export default () => ({
  md: '(min-width: 768px)',
  sm: '(min-width: 425px)',
});
